var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}.cls-2,.cls-3{isolation:isolate;}.cls-3{font-size:128.02px;font-family:Causten-ExtraBold, Causten;font-weight:800;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.56,635.36V547.52H492.89A12.12,12.12,0,0,0,505,535.42V370.69a12.11,12.11,0,0,0-12.12-12.1H150.56V64.68H458.67V172.79a12.12,12.12,0,0,0,12.11,12.1H579.07V635.36ZM119.84,382.78H480.78V523.32H119.84Zm363.07-301,79,78.9h-79Zm120.37,90.59V172a11.38,11.38,0,0,0-.2-1.54h0a11.09,11.09,0,0,0-.41-1.5l-.14-.39a13.29,13.29,0,0,0-.59-1.34v-.1a13.67,13.67,0,0,0-.82-1.31l-.26-.34a12.59,12.59,0,0,0-1-1.19h0L479.36,44a11.8,11.8,0,0,0-1.22-1c-.11-.08-.22-.17-.33-.24a12.37,12.37,0,0,0-1.33-.84h-.07a12.06,12.06,0,0,0-1.38-.61l-.36-.13a12.46,12.46,0,0,0-3.08-.61H138.45a12.11,12.11,0,0,0-12.12,12.1h0v306H107.72a12.11,12.11,0,0,0-12.12,12.1h0V535.41a12.11,12.11,0,0,0,12.12,12.1h18.61v99.93a12.11,12.11,0,0,0,12.12,12.1H591.18a12.11,12.11,0,0,0,12.12-12.1V172.36Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(169.31 494.61)"
  }, "DOC"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.885a3ebd3a9afbc59ea49f3d87b47f7e.svg";
export { ForwardRef as ReactComponent };